import React from 'react';
import { Building2, Heart, Factory, ShoppingCart, Smartphone, Building } from 'lucide-react';

const LatestCase = () => {
  const industries = [
	  {
		icon: <Heart className="h-12 w-12" />,
		title: 'Healthcare',
		description: 'Computer vision diagnostics, symptom bots, EHR parsing',
		stats: '150+ Healthcare Providers'
	  },
	  {
		icon: <Factory className="h-12 w-12" />,
		title: 'CleanTech',
		description: 'Emission tracking, ESG report automation',
		stats: '60+ Manufacturing Plants'
	  },
    {
      icon: <Building className="h-12 w-12" />,
      title: 'Financial Services',
      description: 'Digital banking solutions, regulatory compliance, and risk management systems.',
      stats: '30+ Financial Institutions'
    },
    {
      icon: <ShoppingCart className="h-12 w-12" />,
      title: 'Retail & E-commerce',
      description: 'Inventory management, Visual search, smart recommendations, and product AI copy.',
      stats: '50+ Retail Brands'
    },
    {
      icon: <Smartphone className="h-12 w-12" />,
      title: 'EdTech',
      description: 'AI quizzes, adaptive learning, tutoring chatbots',
      stats: '60+ Tech Companies'
    },
    {
      icon: <Building2 className="h-12 w-12" />,
      title: 'Enterprise Solutions',
      description: 'Document AI, dashboards, voice agents.',
      stats: '40+ Real Estate Firms'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-12 h-0.5 bg-corporate-accent"></div>
            <span className="text-corporate-title font-semibold text-lg tracking-wide">Industries We Empower</span>
            <div className="w-12 h-0.5 bg-corporate-accent"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-gray-dark mb-4"> Transforming sectors with <span className="text-corporate-red">AI-first,</span> industry-specific innovation.</h2>
          <p className="text-xl text-corporate-gray max-w-3xl mx-auto">
            Deep domain expertise across key industries, delivering tailored solutions 
            that address sector-specific challenges and opportunities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {industries.map((industry, index) => (
            <div
              key={industry.title}
              className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition-all duration-300 text-center group"
            >
              <div className="mb-6 flex justify-center">
                <span className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-white">
                  {React.cloneElement(industry.icon, {
                    className: 'h-10 w-10',
                    style: {
                      stroke: 'url(#industry-gradient)',
                      strokeWidth: 2
                    }
                  })}
                  <svg width="0" height="0">
                    <defs>
                      <linearGradient id="industry-gradient" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#ca262c" />
                        <stop offset="100%" stopColor="#a01f24" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
              </div>
              <h3 className="text-xl font-semibold text-corporate-gray-dark mb-3">
                {industry.title}
              </h3>
              <p className="text-corporate-gray mb-4 leading-relaxed">
                {industry.description}
              </p>
              <div className="text-corporate-accent font-semibold text-sm">
                {industry.stats}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestCase;
